import React from "react";
import { Progress } from "antd";
import { useTranslation } from "react-i18next";
import Colors from "../../../../../themes/Colors";

const CampaignUsageBar = ({ campaign }) => {
  const { t } = useTranslation();
  const total = Number(campaign.contents_displays_total) || 0;
  const approved = Number(campaign.contents_displays_approved) || 0;
  const percent = total > 0 ? Math.round((approved / total) * 100) : 0;

  return (
    <div className="campaignCard__usage">
      <div className="campaignCard__usage-label">
        <span>{t("Approved ads")}</span>
        <span>{percent}%</span>
      </div>
      <Progress
        percent={percent}
        showInfo={false}
        strokeWidth={8}
        strokeColor={Colors.primary}
      />
      <div className="campaignCard__usage-label">
        <span>
          {approved} / {total}
        </span>
      </div>
    </div>
  );
};

export default CampaignUsageBar;
